import { createAction, props } from '@ngrx/store';
import { IPersonaData, IPersonaModel } from '@partners/api';

export class PersonaActions {
  static reset = createAction('[Persona] Reset State');
  static load = createAction('[Persona] Load');
  static loadSuccess = createAction('[Persona] Load Success', props<{ model: IPersonaModel; data: IPersonaData }>());
  static loadFailure = createAction('[Persona] Load Failure', props<{ error: any }>());
  static submit = createAction('[Persona] Submit');
  static submitSuccess = createAction(
    '[Persona] Submit Success',
    props<{ model: IPersonaModel; data: IPersonaData }>()
  );
  static submitFailure = createAction('[Persona] Submit Failure', props<{ error: any }>());
}
